import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import Home from './pages/home';
import Transitions from './pages/transitions';
import Compare from './pages/compare';
import Compare2 from './pages/compare2';
import Citation from './pages/citation';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/compare' element={<Compare />} />
                <Route path='/transitions' element={<Transitions />} />
                <Route path='/compare2' element={<Compare2 />} />
                <Route path='/citation' element={<Citation />} />
            </Routes>
        </Router>
    );
};

export default App;
